module.exports = __webpack_public_path__ + "static/git-c01af5e279df6ed1da78076e05aa5dbf.png";